import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TrafficLightColor } from '../../../analysis/models/criterions/TrafficLightColor';

@Component({
    selector: 'sera-shi',
    templateUrl: './sera-shi.component.html',
    styleUrl: './sera-shi.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraShiComponent {
    @Input()
    label?: string;

    @Input()
    value?: number | null;

    @Input()
    color?: TrafficLightColor | null;

    assetsPath = 'assets/images/OVERVIEW/';

    iconMap: Record<TrafficLightColor, string> = {
        [TrafficLightColor.GREEN]: 'white_logo.svg',
        [TrafficLightColor.YELLOW]: 'black_logo.svg',
        [TrafficLightColor.RED]: 'white_logo.svg'
    };
    defaultIcon = 'gray_logo.svg';

    colorMap: Record<TrafficLightColor, string> = {
        [TrafficLightColor.GREEN]: 'var(--ds-color-surface-positive-strong)',
        [TrafficLightColor.YELLOW]: 'var(--ds-color-surface-caution-strong)',
        [TrafficLightColor.RED]: 'var(--ds-color-surface-critical-strong)'
    };
    defaultColor = 'var(--ds-color-surface-neutral-mild)';

    textColorMap: Record<TrafficLightColor, string> = {
        [TrafficLightColor.GREEN]: 'var(--ds-color-typography-invert)',
        [TrafficLightColor.YELLOW]: 'var(--ds-color-typography-base)',
        [TrafficLightColor.RED]: 'var(--ds-color-typography-invert)'
    };
    defaultTextColor = 'var(--ds-color-typography-neutral)';
}
